/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKubernetes = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m4.293 18.435 1.45-1.45A7.962 7.962 0 0 1 4.062 13H2v-2h2.062A7.96 7.96 0 0 1 5.68 7.094L4.293 5.707l1.414-1.414L7.094 5.68A7.96 7.96 0 0 1 11 4.062V2h2v2.062a7.962 7.962 0 0 1 3.985 1.68l1.45-1.45 1.414 1.415-1.467 1.468A7.958 7.958 0 0 1 19.938 11H22v2h-2.062a7.96 7.96 0 0 1-1.618 3.906l1.53 1.529-1.415 1.414-1.53-1.53A7.96 7.96 0 0 1 13 19.94V22h-2v-2.062a7.958 7.958 0 0 1-3.825-1.556l-1.468 1.467zM11 17.917v-3.088a2.99 2.99 0 0 1-.196-.077L8.607 16.95a5.957 5.957 0 0 0 2.393.968zm2-3.088v3.088a5.967 5.967 0 0 0 2.477-1.026l-2.184-2.183a3.007 3.007 0 0 1-.293.121zm1.708-1.536 2.183 2.184A5.968 5.968 0 0 0 17.917 13h-3.088c-.035.1-.076.198-.121.293zM14.829 11h3.088a5.966 5.966 0 0 0-.968-2.393l-2.197 2.197c.028.064.054.13.077.196zm-1.44-1.66 2.17-2.171A5.97 5.97 0 0 0 13 6.083v3.088c.134.047.264.104.388.169zM11 9.17V6.084A5.968 5.968 0 0 0 8.523 7.11l2.184 2.183c.095-.045.193-.086.293-.121zM6.083 11h3.088c.035-.1.076-.198.121-.293L7.11 8.524A5.968 5.968 0 0 0 6.083 11zm3.088 2H6.083a5.97 5.97 0 0 0 1.086 2.559l2.17-2.17A2.982 2.982 0 0 1 9.172 13z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgKubernetes as Kubernetes };
